import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  IconButton,
} from '@mui/material';

import { RemoveRedEyeOutlined, Visibility } from '@mui/icons-material';
import {
  formatDateAndTime,
  getEnumValue,
  lockWidth,
} from '../../../utils/helper';
import { useNavigate } from 'react-router-dom';
import { IService } from '../../../utils/entities/interface';
import { SkeletonRows } from '../../skeletons/list';
import { ListTable } from '../../molecules/ListTable';

export const ServiceList = ({
  services,
  isLoading,
  headerCells,
}: {
  services: IService[];
  isLoading: boolean;
  headerCells: [string, number][];
}) => {
  const navigate = useNavigate();

  const ServiceIcon = ({ imageUrl }: { imageUrl: string }) => {
    return (
      <img
        src={imageUrl}
        alt="Service Icon"
        style={{ width: '40px', height: '40px' }}
      />
    );
  };

  const actions = [
    {
      icon: <RemoveRedEyeOutlined />,
      // onClick: (row: IBrand) => onManageClick(row._id),
      onClick: (row: IService) => navigate(`/manage/services/${row._id}`),
    },
  ];

  return (
    <ListTable
      headerCells={headerCells}
      rows={services}
      isLoading={isLoading}
      actions={actions}
      renderCell={(service: IService, colIndex: number) => {
        switch (colIndex) {
          case 0:
            return <ServiceIcon imageUrl={service.icon} />;
          case 1:
            return service.name;
          case 2:
            return getEnumValue(service.category);
          case 3:
            return service.isActive ? 'Active' : 'Not Active';
          case 4:
            return formatDateAndTime(service.updatedAt);
          case 5:
            return formatDateAndTime(service.createdAt);
          default:
            return null;
        }
      }}
    />
    // <TableContainer sx={{ scrollbarWidth: 'none', marginTop: 0 }}>
    //   <Table>
    //     <TableBody>
    //       {isLoading && <SkeletonRows />}
    //       {!isLoading &&
    //         services.map((service) => (
    //           <TableRow key={service._id}>
    //             <TableCell sx={{ ...lockWidth(15), textAlign: 'center' }}>
    //               <ServiceIcon imageUrl={service.icon} />
    //             </TableCell>

    //             <TableCell sx={{ ...lockWidth(65), textAlign: 'center' }}>
    //               {service.name}
    //             </TableCell>

    //             <TableCell sx={{ ...lockWidth(70), textAlign: 'center' }}>
    //               {getEnumValue(service.category)}
    //             </TableCell>

    //             <TableCell
    //               sx={{
    //                 ...lockWidth(30),
    //                 textAlign: 'center',
    //               }}
    //             >
    //               {service.isActive ? 'Active' : 'Not Active'}
    //             </TableCell>
    //             <TableCell
    //               sx={{
    //                 ...lockWidth(60),
    //                 textAlign: 'center',
    //               }}
    //             >
    //               {formatDateAndTime(service.createdAt)}
    //             </TableCell>
    //             <TableCell
    //               sx={{
    //                 ...lockWidth(60),
    //                 textAlign: 'center',
    //               }}
    //             >
    //               {formatDateAndTime(service.createdAt)}
    //             </TableCell>

    //             <TableCell
    //               sx={{
    //                 ...lockWidth(20),
    //                 textAlign: 'center',
    //               }}
    //             >
    //               <IconButton
    //                 onClick={() => navigate(`/manage/services/${service._id}`)}
    //                 aria-label="view"
    //               >
    //                 <Visibility />
    //               </IconButton>
    //             </TableCell>
    //           </TableRow>
    //         ))}
    //     </TableBody>
    //   </Table>
    // </TableContainer>
  );
};
